import { ref, computed, watch, openBlock, createElementBlock, normalizeClass, createElementVNode, renderSlot, createCommentVNode } from 'vue';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { CHANGE_EVENT, INPUT_EVENT } from './utils/constants';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * kid token
   */
  token: propTypes.string(),
  modelValue: propTypes["boolean"]().def(false),
  disabled: propTypes["boolean"]().def(false)
};
var emits = [CHANGE_EVENT, INPUT_EVENT];

var _createComponent = createComponent('switch'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var checked = ref(props.modelValue);
    // switch容器的class
    var switchClassNames = computed(function () {
      var token = props.token;
      var classNames = _defineProperty({}, "".concat(className), true);
      if (token) {
        classNames["".concat(token)] = true;
      }
      return classNames;
    });
    function onChange() {
      if (props.disabled) {
        return;
      }
      var val = !checked.value;
      emit(INPUT_EVENT, val);
      emit(CHANGE_EVENT, val);
    }
    watch(function () {
      return props.modelValue;
    }, function (val) {
      checked.value = val;
    });
    return {
      className: className,
      switchClassNames: switchClassNames,
      checked: checked,
      onChange: onChange
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.switchClassNames)
  }, [createElementVNode("i", {
    "class": normalizeClass(["".concat(_ctx.className, "__ui"), {
      active: _ctx.checked
    }, {
      disabled: _ctx.disabled
    }]),
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.onChange && _ctx.onChange.apply(_ctx, arguments);
    })
  }, null, 2 /* CLASS */), _ctx.$slots["default"] ? (openBlock(), createElementBlock("span", {
    key: 0,
    "class": normalizeClass("".concat(_ctx.className, "__label"))
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/switch/switch.vue";

var _Switch = script;

export { _Switch as default };
